import { addQueryParams } from 'shared/javascripts/util/query'
import { getGeolocation, GeolocationError } from '../util/geolocation'

up.compiler(
  '[data-load-career-sidebar-async]',
  async (_element: HTMLElement, { target, url }: { target: string; url: string }) => {
    try {
      const { latitude, longitude } = await getGeolocation({
        mayAskForPermission: false,
        timeout: 500,
      })
      url = addQueryParams(url, { score_via_place: `${latitude},${longitude}` })
    } catch (error) {
      if (!(error instanceof GeolocationError)) {
        throw error
      }
    }

    up.render({ target, url, history: false, navigate: false })
  },
)
